'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\n\t', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\tdisplay: none;\n\n\t', ';\n'], ['\n\tdisplay: none;\n\n\t', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n\tposition: relative;\n'], ['\n\tposition: relative;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n\n    width: 200px;\n\n\ttransform: ', ';\n\n    @media (min-width: ', ') {\n        width: 300px;\n\n        ', '\n\n        ', '\n    } \n\n    min-height: ', ';\n\n    max-height: 294px;\n    position: absolute;\n    z-index: 1001;\n\n    ', '\n\n    ', '\n\n    ', '\n    \n    ', '\n        \n    background-color: ', ';\n    color: ', ';\n    border-radius: ', ';\n    box-shadow: 0 -1px 8px 0 rgba(0,0,0,0.15);\n    \n    visibility: ', ';\n    transition: opacity 0.5s;\n\n    &:after {\n\t\tcontent: "";\n\t\tposition: absolute;\n        z-index: 1002;\n        background-color: ', ';\n        \n        ', '\n        \n        ', '\n        \n        ', '\n        \n        ', '\n        \n        height: 10px;\n\t\twidth: 10px;\n    }\n'], ['\n\n    width: 200px;\n\n\ttransform: ', ';\n\n    @media (min-width: ', ') {\n        width: 300px;\n\n        ', '\n\n        ', '\n    } \n\n    min-height: ', ';\n\n    max-height: 294px;\n    position: absolute;\n    z-index: 1001;\n\n    ', '\n\n    ', '\n\n    ', '\n    \n    ', '\n        \n    background-color: ', ';\n    color: ', ';\n    border-radius: ', ';\n    box-shadow: 0 -1px 8px 0 rgba(0,0,0,0.15);\n    \n    visibility: ', ';\n    transition: opacity 0.5s;\n\n    &:after {\n\t\tcontent: "";\n\t\tposition: absolute;\n        z-index: 1002;\n        background-color: ', ';\n        \n        ', '\n        \n        ', '\n        \n        ', '\n        \n        ', '\n        \n        height: 10px;\n\t\twidth: 10px;\n    }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n\theight: 10px;\n\tmargin: 10px;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n'], ['\n\theight: 10px;\n\tmargin: 10px;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n\tmargin-right: 20px;\n\tmargin-left: 20px;\n\tmargin-bottom: 20px;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tmax-height: 243px;\n\n\t&::-webkit-scrollbar {\n\t\twidth: 5px;\n\t  }\n\t  &::-webkit-scrollbar-thumb {\n\t\tbackground: ', ';\n\t\tborder-radius: ', ';\n\t\t&:hover {\n\t\t  background: ', ';\n\t\t}\n\t  }\n'], ['\n\tmargin-right: 20px;\n\tmargin-left: 20px;\n\tmargin-bottom: 20px;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tmax-height: 243px;\n\n\t&::-webkit-scrollbar {\n\t\twidth: 5px;\n\t  }\n\t  &::-webkit-scrollbar-thumb {\n\t\tbackground: ', ';\n\t\tborder-radius: ', ';\n\t\t&:hover {\n\t\t  background: ', ';\n\t\t}\n\t  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n\n'], ['\n\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../constants/colors');

var _radius = require('../../constants/radius');

var _screenSize = require('../../constants/screenSize');

var _sizes = require('../../constants/sizes');

var _closeButton = require('../../atoms/buttons/closeButton');

var _closeButton2 = _interopRequireDefault(_closeButton);

var _overlay = require('../../atoms/overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _informationModal = require('../../organisms/modals/informationModal');

var _informationModal2 = _interopRequireDefault(_informationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ToolTipModal = _styledComponents2.default.div(_templateObject, function (_ref) {
	var mode = _ref.mode;
	return mode !== 'modal' && '\n    @media (min-width: ' + _screenSize.ScreenSize.sm + ') {\n        display: none;\n    }';
});

var ToolTipPopover = _styledComponents2.default.div(_templateObject2, function (_ref2) {
	var mode = _ref2.mode;
	return mode !== 'modal' && '\n    @media (min-width: ' + _screenSize.ScreenSize.sm + ') {\n        display: flex;\n    }';
});

var ToolTipComponent = _styledComponents2.default.div(_templateObject3);

var ToolTipContent = _styledComponents2.default.div(_templateObject4, function (_ref3) {
	var position = _ref3.position;
	return position === 'top' || position === 'bottom' ? 'translateX(-50%)' : 'none';
}, _screenSize.ScreenSize.lg, function (_ref4) {
	var position = _ref4.position;
	return position === 'top' && 'bottom: 40px; left: 15px;';
}, function (_ref5) {
	var position = _ref5.position;
	return position === 'bottom' && 'top: 40px; left: 15px;';
}, function (_ref6) {
	var visible = _ref6.visible;
	return visible ? '80px' : '0px';
}, function (_ref7) {
	var position = _ref7.position;
	return position === 'top' && 'bottom: 40px; left: 15px;';
}, function (_ref8) {
	var position = _ref8.position;
	return position === 'bottom' && 'top: 40px; left: 15px;';
}, function (_ref9) {
	var position = _ref9.position;
	return position === 'left' && 'top: -25px; right: 40px;';
}, function (_ref10) {
	var position = _ref10.position;
	return position === 'right' && 'top: -25px; left: 40px;';
}, _colors.Colors.LightMode, _colors.Colors.claimBlack, _radius.Radius.large, function (_ref11) {
	var visible = _ref11.visible;
	return visible ? 'visible' : 'hidden';
}, _colors.Colors.LightMode, function (_ref12) {
	var position = _ref12.position;
	return position === 'top' && 'top: calc(100% - 5px);\n            left: calc(50% - 5px);\n            box-shadow: -1px 1px 2px -1px rgba(0,0,0,0.15);\n            transform: rotate(-45deg);';
}, function (_ref13) {
	var position = _ref13.position;
	return position === 'bottom' && 'bottom: calc(100% - 5px); \n            left: calc(50% - 5px); \n            box-shadow: -1px 1px 2px -1px rgba(0,0,0,0.15); \n            transform: rotate(135deg);';
}, function (_ref14) {
	var position = _ref14.position;
	return position === 'left' && 'top: 35px; \n            left: 195px; \n            box-shadow: -1px 1px 2px -1px rgba(0,0,0,0.15); \n            transform: rotate(225deg);\n            @media (min-width: ' + _screenSize.ScreenSize.lg + ') {\n                left: 295px; \n            } \n            ';
}, function (_ref15) {
	var position = _ref15.position;
	return position === 'right' && 'top: 35px; \n            right: 195px; \n            box-shadow: -1px 1px 2px -1px rgba(0,0,0,0.15); \n            transform: rotate(45deg);\n            @media (min-width: ' + _screenSize.ScreenSize.lg + ') {\n                right: 295px; \n            } \n            ';
});

var ToolTipHeader = _styledComponents2.default.div(_templateObject5);

var ToolTipBody = _styledComponents2.default.div(_templateObject6, _colors.Colors.cello, _radius.Radius.large, _colors.Colors.cello45);

var ToggleWrapper = _styledComponents2.default.div(_templateObject7);

var ToolTip = function (_React$Component) {
	_inherits(ToolTip, _React$Component);

	function ToolTip(props) {
		_classCallCheck(this, ToolTip);

		var _this = _possibleConstructorReturn(this, (ToolTip.__proto__ || Object.getPrototypeOf(ToolTip)).call(this, props));

		_this.state = {
			hover: false,
			visible: false
		};
		return _this;
	}

	_createClass(ToolTip, [{
		key: 'getToolTipToggle',
		value: function getToolTipToggle() {
			var color = this.props.color || _colors.Colors.StrokeVeryDark;

			if (this.props.disabled && this.props.disabled === true) {
				color = _colors.Colors.StrokeVeryLight;
			} else if (this.state.visible === true) {
				color = _colors.Colors.Primary;
			} else if (this.state.hover === true) {
				color = _colors.Colors.Primary;
			}

			return this.getToolTipIcon(color);
		}
	}, {
		key: 'getToolTipIcon',
		value: function getToolTipIcon(color) {
			return _react2.default.createElement(
				'svg',
				{ xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24' },
				_react2.default.createElement(
					'g',
					{ transform: 'translate(24 24) rotate(180)' },
					_react2.default.createElement('rect', { width: '24', height: '24', fill: 'transparent' }),
					_react2.default.createElement('path', { d: 'M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,2a8,8,0,1,0,8,8A8.009,8.009,0,0,0,10,2Zm.5,12h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,10.5,14ZM9.468,10a.25.25,0,0,1-.248-.22l-.4-3.22a.5.5,0,0,1,.5-.56H10.68a.5.5,0,0,1,.5.56l-.4,3.22a.25.25,0,0,1-.248.22H9.468Z', transform: 'translate(2 2)', fill: color })
				)
			);
		}
	}, {
		key: 'getToolTipPosition',
		value: function getToolTipPosition() {
			var node = _reactDom2.default.findDOMNode(this);

			var position = 'right';

			if (node) {
				var nodePosition = node.getBoundingClientRect();

				var root = document.getElementById('app').getBoundingClientRect();

				var right = root.right - nodePosition.x;

				var bottom = root.height + root.y - nodePosition.y;

				var top = nodePosition.y;

				var spaceRight = right >= 250;

				var spaceBottom = bottom >= 300;

				var spaceTop = nodePosition.y >= 125;

				if (spaceBottom && !spaceRight || !spaceTop) {
					position = 'bottom';
				} else if (!spaceBottom) {
					position = 'top';
				}
			}

			return 'right';
		}
	}, {
		key: 'showToolTip',
		value: function showToolTip() {
			if (this.state.visible === false) {
				this.setState({ visible: true, hover: false });
			}
		}
	}, {
		key: 'hideToolTip',
		value: function hideToolTip() {
			if (this.state.visible === true) {
				this.setState({ visible: false, hover: false });
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var toolTipPosition = this.getToolTipPosition();

			var toolTipToggle = this.getToolTipToggle();

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					ToolTipModal,
					{ mode: this.props.mode },
					this.props.disabled === true ? this.getToolTipIcon(_colors.Colors.StrokeVeryLight) : _react2.default.createElement(_informationModal2.default, {
						size: _sizes.Sizes.lg,
						name: 'tooltipModal',
						footerText: this.props.footerText,
						toggle: _react2.default.createElement(
							ToolTipComponent,
							{ onMouseOver: function onMouseOver() {
									return _this2.setState({ hover: true });
								}, onMouseLeave: function onMouseLeave() {
									return _this2.setState({ hover: false });
								} },
							toolTipToggle
						),
						items: this.props.children
					})
				),
				_react2.default.createElement(
					ToolTipPopover,
					{ mode: this.props.mode },
					_react2.default.createElement(_overlay2.default, { transparent: true, visible: this.state.visible, clickEvent: function clickEvent() {
							return _this2.hideToolTip();
						} }),
					_react2.default.createElement(
						ToolTipComponent,
						{ onMouseOver: function onMouseOver() {
								return _this2.setState({ hover: true });
							}, onMouseLeave: function onMouseLeave() {
								return _this2.setState({ hover: false });
							} },
						_react2.default.createElement(
							ToggleWrapper,
							{ onClick: function onClick() {
									return _this2.state.visible ? _this2.hideToolTip() : _this2.showToolTip();
								} },
							toolTipToggle
						),
						_react2.default.createElement(
							ToolTipContent,
							{ position: toolTipPosition, visible: this.state.visible },
							_react2.default.createElement(
								ToolTipHeader,
								null,
								_react2.default.createElement(_closeButton2.default, { clickEvent: function clickEvent() {
										return _this2.hideToolTip();
									}, size: _sizes.Sizes.sm })
							),
							_react2.default.createElement(
								ToolTipBody,
								null,
								this.props.children
							)
						)
					)
				)
			);
		}
	}]);

	return ToolTip;
}(_react2.default.Component);

exports.default = ToolTip;